import { t } from './i18n';
import { store } from '../app/store';

export function openShortcutsModal(): void {
  const container = document.getElementById('modal-container');
  const card = document.getElementById('modal-card');
  if (!container || !card) return;

  const lang = store.getState().language;

  card.innerHTML = `
    <div class="modal-header">
      <h3 class="modal-title">${t('shortcuts_title', lang)}</h3>
      <button class="modal-close-btn" id="modal-close-btn" aria-label="Close">&times;</button>
    </div>
    <div class="shortcuts-grid" style="display: grid; gap: 0.75rem; font-size: 0.875rem;">
      <div class="shortcut-item" style="display: flex; justify-content: space-between; border-bottom: 1px solid rgba(255,255,255,0.06); padding-bottom: 0.4rem;">
        <span style="color: var(--accent-gold); font-weight: 600;">1 – 6</span>
        <span>${t('shortcuts_views', lang)}</span>
      </div>
      <div class="shortcut-item" style="display: flex; justify-content: space-between; border-bottom: 1px solid rgba(255,255,255,0.06); padding-bottom: 0.4rem;">
        <span style="color: var(--accent-gold); font-weight: 600;">Drag / Touch</span>
        <span>${t('shortcuts_drag', lang)}</span>
      </div>
      <div class="shortcut-item" style="display: flex; justify-content: space-between; border-bottom: 1px solid rgba(255,255,255,0.06); padding-bottom: 0.4rem;">
        <span style="color: var(--accent-gold); font-weight: 600;">Right Drag / 2-finger</span>
        <span>${t('shortcuts_right_drag', lang)}</span>
      </div>
      <div class="shortcut-item" style="display: flex; justify-content: space-between; border-bottom: 1px solid rgba(255,255,255,0.06); padding-bottom: 0.4rem;">
        <span style="color: var(--accent-gold); font-weight: 600;">Scroll / Pinch</span>
        <span>${t('shortcuts_scroll', lang)}</span>
      </div>
      <div class="shortcut-item" style="display: flex; justify-content: space-between; border-bottom: 1px solid rgba(255,255,255,0.06); padding-bottom: 0.4rem;">
        <span style="color: var(--accent-gold); font-weight: 600;">W A S D / Q E</span>
        <span>${t('shortcuts_fly', lang)}</span>
      </div>
      <div class="shortcut-item" style="display: flex; justify-content: space-between; border-bottom: 1px solid rgba(255,255,255,0.06); padding-bottom: 0.4rem;">
        <span style="color: var(--accent-gold); font-weight: 600;">Arrow keys / Joystick</span>
        <span>${t('shortcuts_boat', lang)}</span>
      </div>
      <div class="shortcut-item" style="display: flex; justify-content: space-between; border-bottom: 1px solid rgba(255,255,255,0.06); padding-bottom: 0.4rem;">
        <span style="color: var(--accent-gold); font-weight: 600;">T / Shift+T</span>
        <span>${t('shortcuts_time', lang)}</span>
      </div>
      <div class="shortcut-item" style="display: flex; justify-content: space-between; border-bottom: 1px solid rgba(255,255,255,0.06); padding-bottom: 0.4rem;">
        <span style="color: var(--accent-gold); font-weight: 600;">Space</span>
        <span>${t('shortcuts_pause', lang)}</span>
      </div>
      <div class="shortcut-item" style="display: flex; justify-content: space-between; border-bottom: 1px solid rgba(255,255,255,0.06); padding-bottom: 0.4rem;">
        <span style="color: var(--accent-gold); font-weight: 600;">X</span>
        <span>${t('shortcuts_speed', lang)}</span>
      </div>
      <div class="shortcut-item" style="display: flex; justify-content: space-between; border-bottom: 1px solid rgba(255,255,255,0.06); padding-bottom: 0.4rem;">
        <span style="color: var(--accent-gold); font-weight: 600;">H</span>
        <span>${t('shortcuts_hud', lang)}</span>
      </div>
      <div class="shortcut-item" style="display: flex; justify-content: space-between; border-bottom: 1px solid rgba(255,255,255,0.06); padding-bottom: 0.4rem;">
        <span style="color: var(--accent-gold); font-weight: 600;">P / O</span>
        <span>Pixel Art / Ink Lines</span>
      </div>
      <div class="shortcut-item" style="display: flex; justify-content: space-between; border-bottom: 1px solid rgba(255,255,255,0.06); padding-bottom: 0.4rem;">
        <span style="color: var(--accent-gold); font-weight: 600;">F</span>
        <span>${t('shortcuts_photo', lang)}</span>
      </div>
      <div class="shortcut-item" style="display: flex; justify-content: space-between; border-bottom: 1px solid rgba(255,255,255,0.06); padding-bottom: 0.4rem;">
        <span style="color: var(--accent-gold); font-weight: 600;">M / N / B</span>
        <span>Mute / Next / Prev Music</span>
      </div>
      <div class="shortcut-item" style="display: flex; justify-content: space-between;">
        <span style="color: var(--accent-gold); font-weight: 600;">[ ]</span>
        <span>${t('shortcuts_scene_nav', lang)}</span>
      </div>
    </div>
  `;

  container.classList.remove('hidden');

  const closeBtn = document.getElementById('modal-close-btn');
  const backdrop = document.getElementById('modal-backdrop');

  const closeModal = () => {
    container.classList.add('hidden');
  };

  closeBtn?.addEventListener('click', closeModal, { once: true });
  backdrop?.addEventListener('click', closeModal, { once: true });
}
